/**
 * @method normalizeToCamelcase
 * @param {string} string to convert into camelcase.
 * @description Normalizes a string into a camelcase.
 * @return Camelcase string.
 */
// @ts-expect-error FIXME: TS7006 - strict mode migration
export const normalizeToCamelcase = (string) => {
  const regex = /\s+(\w)?/gi;

  if (!string) {
    return '';
  }

  return string
    .toLowerCase()
    // @ts-expect-error FIXME: TS6133 - strict mode migration
    .replace(regex, (match, text) => text.toUpperCase());
};
